import type { IUserKeywordGroup as KeywordGroupData } from "app/services/keyword-groups";

import { AVAILABLE_KEYWORD_LIST_TYPES } from "./constants";
import { createKeywordGroupEntity, createSearchTermEntity, createAiTopicEntity } from "./entities";
import type { KeywordListType, KeywordListEntity } from "./types";

export {
    buildKeywordGroupKeywordListId,
    buildSearchTermKeywordListId,
    buildAiTopicKeywordListId,
} from "./id-builders";

export function isKeywordListType(key: unknown): key is KeywordListType {
    if (typeof key !== "string") {
        return false;
    }

    return AVAILABLE_KEYWORD_LIST_TYPES.includes(key as KeywordListType);
}

export function parseKeywordListId(
    keywordListId: string,
    keywordGroupMap?: Map<string, KeywordGroupData>,
): KeywordListEntity | null {
    const parts = keywordListId.split(";");

    if (parts.length === 0) {
        return null;
    }

    const entityType = parts[0];

    switch (entityType) {
        case "KeywordGroup": {
            if (parts.length !== 2) {
                return null;
            }
            const groupId = parts[1];
            const keywordGroupData = keywordGroupMap?.get(groupId);
            const name = keywordGroupData?.Name ?? groupId;
            return createKeywordGroupEntity({ type: "KeywordGroup", keywordGroupId: groupId }, name);
        }
        case "SearchTerm": {
            if (parts.length !== 3) {
                return null;
            }
            const seed = parts[1];
            const country = parseInt(parts[2], 10);
            if (isNaN(country)) {
                return null;
            }
            return createSearchTermEntity({ type: "SearchTerm", seed, country }, seed);
        }
        case "AiTopic": {
            if (parts.length !== 3) {
                return null;
            }
            const seed = parts[1];
            const country = parseInt(parts[2], 10);
            if (isNaN(country)) {
                return null;
            }
            return createAiTopicEntity({ type: "AiTopic", seed, country }, seed);
        }
        default:
            return null;
    }
}
